import { OngService } from "./OngService";
import { FluxoBancarioService } from "./FluxoBancarioService";

export {
    OngService,
    FluxoBancarioService
}